import React from 'react';
import PointListFullModeMutateSingleVoyage
    from "@containers/singleVoyage/mutateVoyage/points/pointsList/fullMode/PointListFullModeMutateSingleVoyage";
import PointListMiniModeMutateSingleVoyage
    from "@containers/singleVoyage/mutateVoyage/points/pointsList/miniMode/PointListMiniModeMutateSingleVoyage";

interface IProps {
    miniMode: boolean,
}

const PointsListMutateSingleVoyage = ({miniMode}: IProps) => {

    if (miniMode) {
        return <PointListMiniModeMutateSingleVoyage/>
    }
    return (
        <PointListFullModeMutateSingleVoyage/>
    );
};

export default PointsListMutateSingleVoyage;